import { render, staticRenderFns } from "./printed.vue?vue&type=template&id=4496a51b&scoped=true&"
import script from "./printed.vue?vue&type=script&lang=js&"
export * from "./printed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4496a51b",
  null
  
)

export default component.exports